import { Controller } from '@hotwired/stimulus';

// The vacated beat's phases are CSS transition delays off one `.is-active` class, so no selector can
// tell that a slide has resolved to its card-and-window pair — which is narrower than the three-card
// row the stage is sized to. This marks that moment so the well can close in on it, reading the delay
// from the custom property the choreography already uses rather than restating it here.
export default class extends Controller {
  connect() {
    this.__observer = new MutationObserver(() => this.__sync());
    this.__observer.observe(this.element, { subtree: true, attributes: true, attributeFilter: ['class'] });
    // A restart re-adds `is-active` to the slide already holding it, which no mutation record can be told
    // apart from noise — without this the well stays closed in over a beat playing from the top again.
    this.__restart = () => {
      this.__active = null;
      this.__sync();
    };
    this.element.addEventListener('showcase:beat-restart', this.__restart);
    this.__sync();
  }

  disconnect() {
    this.__observer?.disconnect();
    this.__observer = null;
    this.element.removeEventListener('showcase:beat-restart', this.__restart);
    clearTimeout(this.__timer);
    this.__active = null;
  }

  // Keyed on the active slide changing, not on any class change: the beat toggles `is-pressed`,
  // `is-enabled` and the spotlight classes throughout, and re-arming on those would cancel the timer
  // every time and never resolve.
  __sync() {
    const active = this.element.querySelector('.feature-showcase-slide.is-active');
    if (active === this.__active) return;

    this.__active = active;
    clearTimeout(this.__timer);
    this.element.classList.remove('is-resolved');
    if (active) this.__timer = setTimeout(() => this.element.classList.add('is-resolved'), this.__resolveAt);
  }

  get __resolveAt() {
    return parseFloat(getComputedStyle(this.element).getPropertyValue('--vacated-t-migrate-at')) || 0;
  }
}
